import React from 'react';
import { Box, Typography } from '@mui/material';
import FiltersBar from '../FiltersBar';
import WatchLogViewer from '../WatchLogViewer';
import FileInfo from '../FileInfo';
import CopyCerts from '../CopyCerts';
import StoryItems from '../StoryItems';

const EventsPanel = React.memo(({ appInfo, viewConfig = {} }) => {
  const showWatchLogViewer = !!viewConfig?.watchLogViewerSection;
  const showFilters = !!viewConfig?.filters;
  const showFileInfo = !!viewConfig?.fileInfo;
  const showCertInfo = !!viewConfig?.certInfo;
  const showProcessInfo = !!viewConfig?.processInfo;

  if (!showWatchLogViewer) {
    return (
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Watch log viewer is hidden in this view.
        </Typography>
      </Box>
    );
  }

  const showToolbar = showFilters || showFileInfo || showCertInfo || showProcessInfo;
  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {showToolbar && (
        <Box sx={{ 
          py: 0.5, 
          px: 1, 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1
        }}>
          {showFilters && (
            <Box sx={{ flex: 1 }}>
              <FiltersBar />
            </Box>
          )}
          {showFileInfo && (
            <Box sx={{ flexShrink: 0 }}>
              <FileInfo fileinfoUrl={appInfo?.fileinfo} />
            </Box>
          )}
          {showCertInfo && (
            <Box sx={{ flexShrink: 0 }}>
              <CopyCerts copycertUrl={appInfo?.copycert} />
            </Box>
          )}
          {showProcessInfo && (
            <Box sx={{ flexShrink: 0 }}>
              <StoryItems storyitemsUrl={appInfo?.storyitems} />
            </Box>
          )}
        </Box>
      )}
      <Box sx={{ flex: 1, overflow: 'hidden', minHeight: 0, height: '100%' }}>
        <WatchLogViewer appInfo={appInfo} />
      </Box>
    </Box>
  );
});

export default EventsPanel;
